import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.colors.white};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  border-radius: 0.8rem;
  padding: 2rem;
  margin-bottom: 2rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`

export const Title = styled.div`
  ${(p) => p.theme.bold}
  font-size: 1.8rem;
`

export const ToggleContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  background: ${(p) => p.theme.colors.greyLighter};
  border-radius: 0.8rem;
  padding: 0.4rem;
`

export const ToggleButton = styled.button<{ $active: boolean }>`
  padding: 0.8rem 1.6rem;
  border: none;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(p) => (p.$active ? p.theme.colors.turquoiseDark : "transparent")};
  color: ${(p) => (p.$active ? p.theme.colors.white : p.theme.colors.greyDark)};

  &:hover {
    background: ${(p) => (p.$active ? p.theme.colors.turquoiseDark : p.theme.colors.greyLight)};
  }
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 40rem;

  ${(p) => p.theme.mQ.MEDIA_MAX_MEDIUM} {
    height: 30rem;
  }
`

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40rem;
  font-size: 1.4rem;
  color: ${(p) => p.theme.colors.greyDark};
`
